// resources/js/Utils/profileUtils.js

/**
 * Calculates the profile completeness percentage.
 * Total potential score is >100 to allow for some optionality.
 */
export const calculateProfileCompleteness = (data, scripts = []) => {
  let score = 0;
  
  // 1. Core Identity (50 points)
  // Weighted heavily because these are essential for the page to look good
  if (data.display_name?.trim()) score += 15;
  if (data.nickname?.trim()) score += 15;
  if (data.bio?.trim()) score += 20;

  // 2. Professional Details (30 points)
  if (data.location?.trim()) score += 10;
  if (data.specialty_tagline?.trim()) score += 10;
  
  // Check if primary_genres exists and has items
  if (data.primary_genres && data.primary_genres.length > 0) score += 10;

  // 3. Portfolio Content (20 points max)
  // We cap this at 20 points (e.g., 2 scripts * 10 points each)
  // This ensures writers with only 1 great script aren't penalized too heavily
  const scriptCount = scripts ? scripts.length : 0;
  const scriptPoints = Math.min(scriptCount * 10, 20);
  score += scriptPoints;

  // 4. Cap at 100%
  // The raw total is 100 (50+30+20), but this ensures we never display 105%
  return Math.min(score, 100);
};
